// Cấu hình menu điều hướng DÙNG CHUNG cho Sidebar (desktop) và MobileMenuPage (mobile).
// Tách ra đây để 2 nơi không lệch nhau về danh sách mục + quyền hiển thị.

export const NAV_GROUPS = [
  {
    title: 'TỔNG QUAN',
    items: [
      { key: 'dashboard', ico: 'ti-layout-dashboard', label: 'Trang chủ', roles: ['GD', 'TP', 'NV'] },
      { key: 'messages', ico: 'ti-message-circle', label: 'Tin nhắn', roles: ['GD', 'TP', 'NV'] },
      { key: 'chat-tasks', ico: 'ti-checklist', label: 'Công việc chat', roles: ['GD', 'TP', 'NV'] },
      { key: 'chat-report', ico: 'ti-message-report', label: 'Báo cáo chat ngày', roles: ['GD', 'TP', 'NV'] },
    ],
  },
  {
    title: 'KINH DOANH',
    items: [
      { key: 'scan', ico: 'ti-list-search', label: 'Danh sách quét', roles: ['GD', 'TP', 'NV'], scanManual: true },
      { key: 'yahoo-scan', ico: 'ti-alarm', label: 'Quét hạn đơn Yahoo', roles: ['GD', 'TP', 'NV'] },
      { key: 'tasks', ico: 'ti-checklist', label: 'Công việc', roles: ['GD', 'TP', 'NV'] },
      { key: 'cskh', ico: 'ti-headset', label: 'CSKH', roles: ['GD', 'TP', 'NV'], notDept: ['Phòng kế toán', 'Phòng DVKH'], ownDept: 'Phòng CSKH' },
      { key: 'customers', ico: 'ti-users', label: 'Khách hàng', roles: ['GD', 'TP', 'NV'], notDept: 'Phòng kế toán' },
      { key: 'refund', ico: 'ti-receipt-refund', label: 'Đề xuất hoàn tiền', roles: ['GD', 'TP', 'NV'], refund: true },
    ],
  },
  {
    // VẬN HÀNH (port app "i love GTS"): gọi SocSon bằng tài khoản SocSon RIÊNG của từng NV.
    title: 'VẬN HÀNH',
    items: [
      { key: 'ops-lookup', ico: 'ti-zoom-scan', label: 'Tra cứu đơn hàng', roles: ['GD', 'TP', 'NV'], opsSale: true },
      { key: 'ops-pick', ico: 'ti-hand-grab', label: 'Nhặt hàng', roles: ['GD', 'TP', 'NV'], ops: true },
      { key: 'ops-collect', ico: 'ti-package-import', label: 'Nhận đơn giao', roles: ['GD', 'TP', 'NV'], ops: true },
      { key: 'ops-waiting', ico: 'ti-truck-loading', label: 'Nhận hàng đi giao', roles: ['GD', 'TP', 'NV'], ops: true },
      { key: 'ops-delivering', ico: 'ti-truck-delivery', label: 'Giao hàng', roles: ['GD', 'TP', 'NV'], ops: true },
      { key: 'ops-delivered', ico: 'ti-circle-check', label: 'Quản lý đơn giao', roles: ['GD', 'TP', 'NV'], ops: true },
      { key: 'ops-images', ico: 'ti-camera', label: 'Cập nhật ảnh đơn', roles: ['GD', 'TP', 'NV'], opsSale: true },
      { key: 'ops-notify', ico: 'ti-bell-ringing', label: 'Thông báo vận hành', roles: ['GD', 'TP', 'NV'], ops: true },
    ],
  },
  {
    title: 'NHÂN SỰ & KPI',
    items: [
      { key: 'staff', ico: 'ti-user-cog', label: 'Nhân viên', roles: ['GD', 'TP', 'NV'], staffAdmin: true },
      { key: 'payroll', ico: 'ti-report-money', label: 'Quản lý bảng lương', roles: ['GD', 'TP', 'NV'], payrollAdmin: true },
      { key: 'exchange-log', ico: 'ti-history', label: 'Nhật ký trao đổi', roles: ['GD', 'TP', 'NV'], allTP: true, ownDept: 'Phòng CSKH' },
      { key: 'kpi', ico: 'ti-chart-bar', label: 'KPI', roles: ['GD', 'TP', 'NV'] },
      { key: 'overtime', ico: 'ti-calendar-clock', label: 'Lịch trực DVKH', roles: ['GD', 'TP', 'NV'], dept: 'Phòng DVKH' },
      { key: 'overtime-op', ico: 'ti-calendar-clock', label: 'Lịch trực OP', roles: ['GD', 'TP', 'NV'], deptAny: ['Phòng OP', 'Phòng kế toán'] },
      { key: 'overtime-ketoan', ico: 'ti-calendar-clock', label: 'Lịch trực Kế toán', roles: ['GD', 'TP', 'NV'], dept: 'Phòng kế toán' },
    ],
  },
  {
    title: 'BÁO CÁO',
    items: [
      { key: 'weekly-report', ico: 'ti-calendar-stats', label: 'Báo cáo tuần', roles: ['GD', 'TP', 'NV'], allTP: true },
      { key: 'purchase-report', ico: 'ti-shopping-cart', label: 'Báo cáo mua hàng', roles: ['GD', 'TP', 'NV'] },
      { key: 'business-report', ico: 'ti-trending-up', label: 'Báo cáo kinh doanh', roles: ['GD', 'TP', 'NV'], salesTP: true },
      { key: 'cskh-report', ico: 'ti-headset', label: 'Báo cáo CSKH', roles: ['GD', 'TP', 'NV'], allTP: true, ownDept: 'Phòng CSKH' },
      { key: 'finance-report', ico: 'ti-coin', label: 'Báo cáo tài chính', roles: ['GD', 'TP', 'NV'], allTP: true, ownDept: 'Phòng kế toán' },
      { key: 'meetings', ico: 'ti-calendar-event', label: 'Biên bản họp', roles: ['GD', 'TP', 'NV'], meeting: true },
    ],
  },
  {
    title: 'NỘI BỘ',
    items: [
      { key: 'announcements', ico: 'ti-bell', label: 'Thông báo', roles: ['GD', 'TP', 'NV'] },
      { key: 'drive', ico: 'ti-folders', label: 'Kho file', roles: ['GD', 'TP', 'NV'] },
      { key: 'notes', ico: 'ti-notebook', label: 'Ghi chú', roles: ['GD', 'TP', 'NV'] },
      { key: 'guide', ico: 'ti-help-circle', label: 'Hướng dẫn sử dụng', roles: ['GD', 'TP', 'NV'] },
      { key: 'lionjob', ico: 'ti-paw', label: 'Lionjob', roles: ['GD'], gdOnly: true },
    ],
  },
  {
    title: 'GIẢI TRÍ',
    items: [{ key: 'cangua', ico: 'ti-dice', label: 'Cá Ngựa', roles: ['GD', 'TP', 'NV'] }],
  },
  {
    title: 'HỆ THỐNG',
    items: [{ key: 'sync', ico: 'ti-refresh', label: 'Đồng bộ', roles: ['GD', 'TP', 'NV'], scanManual: true }],
  },
];

const REPORT_KEYS = ['weekly-report', 'purchase-report', 'business-report', 'cskh-report', 'finance-report'];

// Các mục/màn thuộc nhóm VẬN HÀNH (App.jsx định tuyến, MobileNav bôi sáng tab, MobileOpsPage liệt kê).
export const OPS_ITEMS = NAV_GROUPS.find((g) => g.title === 'VẬN HÀNH').items;
export const OPS_KEYS = OPS_ITEMS.map((i) => i.key);

// Nhân sự vận hành (Phòng OP kho/giao hàng + Phòng DVKH mua hàng) — KHÔNG tính GĐ/CV dù họ xem được
// mọi màn vận hành. Dùng cho thanh điều hướng mobile: riêng người vận hành mới đổi tab KPI -> Vận hành.
// Xét theo departments (đúng bằng nhánh mở khoá toàn bộ mục VẬN HÀNH trong canSeeOps) -> ai có tab
// này thì chắc chắn có chức năng để bấm; deptHeadOf là bảng khác, không suy ra quyền vận hành.
export function isOpsStaff(me) {
  const depts = (me && me.departments) || [];
  return depts.includes('Phòng OP') || depts.includes('Phòng DVKH');
}

// VẬN HÀNH: GĐ/CV + Phòng OP (kho/giao hàng) + Phòng DVKH (mua hàng — cần "Thông báo vận hành" cho đơn
// cần mua đẩy từ pmbox). Tra cứu đơn + Cập nhật ảnh đơn: thêm Phòng kinh doanh / TP nhóm KD.
// (Chốt chặn thật là tài khoản SocSon của NV — không có quyền bên SocSon thì API trả lỗi.)
export function canSeeOps(me, i) {
  const depts = me.departments || [];
  if (me.role === 'GD' || me.role === 'CV' || depts.includes('Phòng OP') || depts.includes('Phòng DVKH')) return true;
  return !!i.opsSale && (depts.includes('Phòng kinh doanh') || (me.role === 'TP' && !!me.group) || me.isCTV);
}

// Quyền hiển thị 1 mục cho user hiện tại — LOGIC GỐC lấy nguyên từ Sidebar (giữ khớp tuyệt đối).
export function canSeeItem(me, i) {
  if (!me) return false;
  const isAdminRole = me.role === 'GD' || me.role === 'CV';
  const isDeptHead = (me.deptHeadOf || []).length > 0;
  const isOpHead = (me.deptHeadOf || []).includes('Phòng OP');
  if (i.gdOnly) return me.role === 'GD';
  if (isAdminRole) return true;
  if (isOpHead && REPORT_KEYS.includes(i.key)) return false;
  if (!i.roles.includes(me.role)) return false;
  if (i.notDept) {
    const blockedDepts = Array.isArray(i.notDept) ? i.notDept : [i.notDept];
    const inBlocked = blockedDepts.some((d) => (me.departments || []).includes(d));
    const inOwn = i.ownDept && (me.departments || []).includes(i.ownDept);
    if (inBlocked && !inOwn) return false;
  }
  if (i.allTP) return isAdminRole || me.role === 'TP' || isDeptHead || me.isDeputy || (i.ownDept && (me.departments || []).includes(i.ownDept));
  if (i.salesTP) return isAdminRole || (me.role === 'TP' && !!me.group) || isDeptHead || me.isDeputy;
  // Quét thủ công (Đồng bộ): GĐ/CV + TP nhóm KD + trưởng phòng ban + NV Phòng kinh doanh / CTV kinh doanh.
  if (i.scanManual) return isAdminRole || (me.role === 'TP' && !!me.group) || isDeptHead || me.isDeputy
    || (me.role === 'NV' && ((me.departments || []).includes('Phòng kinh doanh') || me.isCTV));
  if (i.meeting) return isAdminRole || me.role === 'TP' || isDeptHead || (me.departments || []).includes('Phòng CSKH');
  if (i.payrollAdmin) return isAdminRole || (me.deptHeadOf || []).includes('Phòng kế toán');
  if (i.staffAdmin) return isAdminRole || (me.deptHeadOf || []).includes('Phòng kế toán'); // Quản lý NV: + trưởng phòng kế toán
  if (i.refund) return isAdminRole || (me.departments || []).includes('Phòng kinh doanh') || (me.departments || []).includes('Phòng kế toán') || (me.deptHeadOf || []).includes('Phòng DVKH');
  if (i.headDept) return isAdminRole || (me.deptHeadOf || []).includes(i.headDept);
  if (i.ops || i.opsSale) return canSeeOps(me, i);
  // deptAny: thuộc BẤT KỲ phòng nào trong danh sách (vd Lịch trực OP: Phòng OP + Phòng kế toán).
  if (i.deptAny) return (i.deptAny || []).some((d) => (me.departments || []).includes(d));
  if (i.dept) return me.role === 'GD' || (me.departments || []).includes(i.dept);
  return true;
}
